import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import AuthProvider from 'providers/AuthProvider';
import { ThemeUIProvider } from 'providers/ThemeUIProvider';

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <AuthProvider>
        <ThemeUIProvider>
          <App />
        </ThemeUIProvider>
      </AuthProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
